import { get } from "lodash";
import React, { useMemo } from "react";
import { RouteComponentProps } from "react-router-dom";
import { Timeline } from "react-twitter-widgets";
import { useAppearance } from "../../../context/appearance";
import { hotspotMakerMetadata } from "../../../context/hotspotMakers/HotspotMakersProvider";

const MakerTweetsTab: React.FC<RouteComponentProps<{ id: string }>> = (
  props
) => {
  const { isDark } = useAppearance();

  const twitterLink = useMemo(
    () => get(hotspotMakerMetadata, [props.match.params.id, "twitterLink"]),
    [props.match.params.id]
  );

  return (
    <div className="mt-6 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      {!twitterLink ? (
        "No twitter account is available for this maker."
      ) : (
        <Timeline
          dataSource={{
            sourceType: "url",
            url: twitterLink
          }}
          options={{
            theme: isDark ? "dark" : "light",
            width: "500"
          }}
        />
      )}
    </div>
  );
};

export default MakerTweetsTab;
